import { render, staticRenderFns } from "./MatrixAnswer.vue?vue&type=template&id=78eafef0&"
import script from "./MatrixAnswer.vue?vue&type=script&lang=js&"
export * from "./MatrixAnswer.vue?vue&type=script&lang=js&"
import style0 from "./MatrixAnswer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VSimpleCheckbox})
